module.exports = __webpack_public_path__ + "img/1549509102.88e05a2f.jpg";